var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"activity-select"},[_c('im-select',{staticClass:"w-full",attrs:{"clearable":"","size":"small","placeholder":"请选择活动","options":_vm.activityList,"loading":_vm.loading},on:{"input":_vm.onInput},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }